module.exports = "https://www.niulinkcloud.com/_next/static/media/mp-lite.5967377475fe2e52d46b76782cb25517.png";